import type { FC } from 'react';
import { lazy } from 'react';
import { useMemoOne } from 'use-memo-one';
import type { UmmsOverviewParams } from 'src/apis/iip-service/types';
import type { IipServiceRequest } from 'src/apis/iip-service/use-iip-service';
import { useUmms } from 'src/apis/iip-service/use-umms';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { useUmmsPageParams } from 'src/pages/market-messages/urgent-market-messages/overview/use-page-params';

const Page = lazy(() => import('./page'));

type Props = {
  iipService: Successful<IipServiceRequest>;
};

export const UrgentMarketMessagesCreate: FC<Props> = ({ iipService }) => {
  const params = useUmmsPageParams();
  const transformedParams = useMemoOne<UmmsOverviewParams>(() => {
    const { start, pageSize, marketParticipantIds, ...rest } = params.value;
    return {
      offset: start,
      limit: pageSize,
      marketParticipantIds: marketParticipantIds.map(
        (marketParticipant) => marketParticipant.value
      ),
      ...rest,
    };
  }, [params.value]);
  const umms = useUmms({ iipService, params: transformedParams });

  if (!umms.response) return <PageSpinner />;

  return <Page umms={umms} />;
};
